import { atom, useAtom } from 'jotai';

const channelTalkAtom = atom(true);

export const useChannelTalkVisible = () => {
  return useAtom(channelTalkAtom);
};
